import React, { useContext, useEffect, useState, Fragment } from "react";
import SocketContext from "../../../../context/SocketContext";

export default function LiveRate({ symbol_id, buy_sell }) {
  const socket = useContext(SocketContext);
  const [Ask, setAsk] = useState(0);
  const [Bid, setBid] = useState(0);
  const [LTP, setLTP] = useState(0);

  useEffect(() => {
    if (!socket || !symbol_id) return;

    // Emit request for live rate
    socket.emit("giverate", symbol_id);

    // Define listener
    const handleTrade = (data) => {
      if (data && typeof data === "object") {
        setAsk(parseFloat(data.Ask));
        setBid(parseFloat(data.Bid));
        setLTP(parseFloat(data.LTP));
      }
    };

    // Attach listener
    socket.on(`trade${symbol_id}`, handleTrade);

    // Cleanup when unmounting or changing symbol
    return () => {
      socket.off(`trade${symbol_id}`, handleTrade);
    };
  }, [socket, symbol_id]);

  /** ⭐ Final price with fallback */
  const finalBid = Bid === 0 ? LTP : Bid;
  const finalAsk = Ask === 0 ? LTP : Ask;

  // Pick correct value
  const displayedRate = buy_sell === 0 ? finalBid : finalAsk;

  return <Fragment>{displayedRate}</Fragment>;
}
